// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__tku+R","jobs_wrapper":"_styles_jobs_wrapper__cslAw"};